import { component } from "picoapp";

export default component(async (node) => {
  const [{ default: KeenSlider }, { useDots }] = await Promise.all([
    import("keen-slider"),
    import("../lib/keen-slider"),
    import("keen-slider/keen-slider.min.css"),
  ]);

  const sliderElement = node.querySelector("[data-keen-slider]");
  const dotsContainer = node.querySelector("[data-dots]");

  // eslint-disable-next-line no-new
  new KeenSlider(
    sliderElement,
    {
      drag: true,
      loop: false,
      slides: {
        perView: 1.5,
        spacing: 16,
      },
      breakpoints: {
        "(min-width: 750px)": {
          disabled: true,
        },
      },
    },
    [useDots(dotsContainer)]
  );
});
